import { restClient } from '../../client';
import { Match, PublicUser, UserProfile } from '../../resources';


export type UsersSearchMatchesInput = {
  term: string;
};


export type UsersSearchMatchesOutput = {
  data: {
    users: {
      match: Match;
      user: PublicUser;
      profile: UserProfile;
    }[];
  };
};


export const usersSearchMatches = restClient.createRequest<UsersSearchMatchesInput, UsersSearchMatchesOutput>({
  url: '/api/v1/users/search_matches',
  method: 'POST',
});
